import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=36b0fc6f"
import script from "./Divider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Divider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Divider.vue?vue&type=style&index=0&id=36b0fc6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports